import Router from "./Router";
import GlobalModule from "./components/Modules/GlobalModule";
import Snowfall from "react-snowfall";

function App() {
  return (
    <GlobalModule>
      <Router />
      {/* <Snowfall
        snowflakeCount={200}
        style={{ position: "fixed", inset: 0, zIndex: 9999, pointerEvents: "none" }}
      /> */}
    </GlobalModule>
  );
}

export default App;